import { render } from "./Message.vue?vue&type=template&id=20e2271e&scoped=true"
const script = {}

import "./Message.vue?vue&type=style&index=0&id=20e2271e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20e2271e"

export default script